module.exports = __webpack_public_path__ + "static/11-7c908f0bf8f951f6cfb4760798684cfd.jpeg";